import { USER_LIST } from "/src/constants";

let cloneObject = function (obj) {
    return JSON.parse(JSON.stringify(obj))
};

let newState = { userList : {} };

export default function ListReducer(state,action)
{
    switch (action.type){

        case USER_LIST :
            newState = cloneObject(state);
            if (action.data !== null) {
                newState = Object.assign({}, newState, {
                    ...action.data,
                    userList: action.data,
                });
            }
            return  newState ;

            default:
            return state || newState;
    }

}

